import { Route } from '../../../config/router'
import { ConsumerLookupCohort, ConsumerLookupAction, ConsumerLookup } from '@afterpaytouch/portal-api/types'
import { checkoutErrors, CrossRegionRedirection } from '../../../model'
import { setCheckoutError, CheckoutAppDispatch } from '../../../state'
import { InitialiseNextRoute } from './types'

export const determineRouteFromConsumerLookup = (
  merchantId: number,
  consumerLookup: ConsumerLookup,
  dispatch: CheckoutAppDispatch,
  cashAuthRoute: Route
): InitialiseNextRoute | CrossRegionRedirection => {
  if (typeof consumerLookup?.cashtag === 'string' && consumerLookup.action === ConsumerLookupAction.CASH_APP_LOGIN) {
    const cashtag = consumerLookup.cashtag
    const existing = (consumerLookup as ConsumerLookup & { exists?: boolean })?.exists ?? false
    return { route: cashAuthRoute, lookup: { cashtag, existing, merchantId } }
  }

  if (
    consumerLookup?.cohort === ConsumerLookupCohort.cross_region_consumer &&
    consumerLookup?.action === ConsumerLookupAction.CROSS_REGION_REDIRECT &&
    consumerLookup.redirectUrl
  ) {
    dispatch(setCheckoutError({ error: checkoutErrors.unsupported_merchant_trading_country }))
    return { crossRegionCheckoutUrl: consumerLookup.redirectUrl }
  }

  if (consumerLookup.action === ConsumerLookupAction.SET_PASSWORD) {
    return { route: Route.ENTER_EMAIL }
  }

  if (consumerLookup?.cohort === ConsumerLookupCohort.existing_consumer) {
    if (consumerLookup?.action === ConsumerLookupAction.LOGIN_OTP) {
      return { route: Route.ONE_TIME_PASSWORD }
    }
    if (consumerLookup?.action === ConsumerLookupAction.LOGIN_PASSWORD) {
      return { route: Route.ENTER_PASSWORD }
    }
    return { route: Route.ENTER_EMAIL }
  }

  return { route: Route.ENTER_EMAIL }
}
